import { SchemaLink } from 'apollo-link-schema';
import { makeExecutableSchema } from 'graphql-tools/dist/makeExecutableSchema';

import * as network from '@confluence/network';

import { ExperimentalSchema } from '../../types/ExperimentalSchema.graphqls';
import {
	createExperienceAwareFetch,
	isExperienceAwareFetchAlwaysEnabled,
} from '../../createExperienceAwareFetch';
import { resolvers } from '../../resolvers';
import { isSLA } from '../../graphqlAssertions';

let schemaLink: SchemaLink | null = null;

const experienceAwareFetch = createExperienceAwareFetch();
const schema = makeExecutableSchema({
	typeDefs: ExperimentalSchema,
	resolvers,
	resolverValidationOptions: {
		requireResolversForResolveType: false,
	},
});

/**
 * Do NOT directly import this file
 */
export function getSchemaLink(): SchemaLink {
	if (schemaLink) {
		return schemaLink;
	}
	return (schemaLink = new SchemaLink({
		schema,
		context: (operation) => ({
			network: {
				...network,
				cfetch:
					isExperienceAwareFetchAlwaysEnabled() || isSLA(operation)
						? experienceAwareFetch
						: network.cfetch,
			},
		}),
	}));
}
